class ReceberFilterModel {

    Empresa: string | null;
    Núm_NF: string | null;
    Cód_Fornecedor: string | null;
    Nome_Fornecedor: string | null;
    Esfera: string | null;
    UF: string | null;
    Documento: string | null;
    banco: string | null;
    status_pagamento: string | null;
    Nome_cta_débito: string | null;
    pagamento_atraso: string | null;
    codigo_contrato: string | null;
    marcador_contrato: string | null;
    num_pregao: string | null;
    classificacao: string | null;
    num_empenho: string | null;
    data_filtro: string | null;
    data_inicio: string | null;
    data_fim: string | null;
    dias_posicao: string | null;
    posicao: string | null;
    Valor_parcela: string | null;
    Valor_recebido: string | null;

    constructor() {
        this.Empresa = null;
        this.Núm_NF = null;
        this.Cód_Fornecedor = null;
        this.Nome_Fornecedor = null;
        this.Esfera = null;
        this.UF = null;
        this.Documento = null;
        this.banco = null;
        this.status_pagamento = null;
        this.Nome_cta_débito = null;
        this.pagamento_atraso = null;
        this.codigo_contrato = null;
        this.marcador_contrato = null;
        this.num_pregao = null;
        this.classificacao = null;
        this.num_empenho = null;
        this.data_filtro = null;
        this.data_inicio = null;
        this.data_fim = null;
        this.dias_posicao = null;
        this.posicao = null;
        this.Valor_parcela = null;
        this.Valor_recebido = null;
    }

}

export default ReceberFilterModel;
